<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('brands-list')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Masters')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('Brands')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('brands-list')}}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
        @if (isRateLimitReached) {
        <div class="rate-limit-reached">
            ALTAIR rate limit has been reached. It will be reset in one minute.
        </div>
        }
    </div>
    }
    <!-- Brands -->
    <mat-card class="altair-card companies-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}} {{t('brand')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-title>
            <mat-card-title>
                <form class="search-box position-relative">
                    <mat-form-field>
                        <mat-label>
                            {{t('select-company')}}
                        </mat-label>
                        <mat-select [(value)]="selectedCompany" (selectionChange)="changeCompany(selectedCompany)">
                            <mat-option>{{t('none')}}</mat-option>
                            <mat-option *ngFor="let company of companies" [value]="company.id">
                                {{company.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </form>
            </mat-card-title>
            <mat-card-subtitle>
                <a mat-button class="add-new-btn" routerLink="/masters/create-brand">
                    + {{t('add-new-brand')}}
                </a>
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="branch-offices-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDisableClear
                        matSortDirection="asc">

                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('name')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.name}}
                            </td>
                        </ng-container>

                        <!-- Domain Column -->
                        <ng-container matColumnDef="domain">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('domain')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.domain}}
                            </td>
                        </ng-container>

                        <!-- Company Column -->
                        <ng-container matColumnDef="companyName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('company')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.companyName}}
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('action')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="action-info">
                                    <a mat-button routerLink="/masters/edit-brand/{{row.id}}"
                                        matTooltip="{{t('edit')}} {{t('brand')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            edit
                                        </i>
                                    </a>
                                    <button type="button" mat-button (click)="delete(row.id)"
                                        matTooltip="{{t('delete')}} {{t('brand')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            delete
                                        </i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{t('no-data-matching')}} "{{input.value}}"</td>
                        </tr>

                    </table>
                </div>
                <mat-paginator [length]="totalItems" [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
